"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_INIT_ERRORS = void 0;
exports.COMPANY_INIT_ERRORS = {
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    SIREN_ALREADY_EXISTS: 'SIREN_ALREADY_EXISTS',
    SIRET_ALREADY_EXISTS: 'SIRET_ALREADY_EXISTS',
};
//# sourceMappingURL=companyInitError.constant.js.map